import { useTranslation } from 'react-i18next'
import { Search, Link, X } from 'lucide-react'
import type { Product } from '@/types/products'

interface SearchInputProps {
  search: string
  setSearch: (v: string) => void
  onFocus: () => void
  results: Product[]
  showDropdown: boolean
  onSelect: (p: Product) => void
  onBlur: () => void
}

export function ProductSearchInput({ search, setSearch, onFocus, results, showDropdown, onSelect, onBlur }: SearchInputProps) {
  const { t } = useTranslation()
  return (
    <div className="relative">
      <Search className="absolute left-3 top-2.5 w-4 h-4 text-neutral-400" />
      <input value={search} onChange={(e) => setSearch(e.target.value)} onFocus={onFocus} onBlur={onBlur}
        placeholder={t('amazonListing.manual.searchProducts')}
        className="w-full pl-9 pr-3 py-2 bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500" />
      {showDropdown && results.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {results.map((p) => (
            <li key={p.id} onMouseDown={() => onSelect(p)}
              className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-neutral-100 dark:hover:bg-neutral-700 text-sm">
              {p.first_image_url && <img src={p.first_image_url} alt="" className="w-6 h-6 rounded object-cover" />}
              <span className="truncate">{p.name}</span>
              {p.sku && <span className="ml-auto text-xs text-neutral-400">{p.sku}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

interface SelectedProductBadgeProps {
  product: Product
  onClear: () => void
}

export function SelectedProductBadge({ product, onClear }: SelectedProductBadgeProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-orange-50 dark:bg-orange-950/30 border border-orange-200 dark:border-orange-800 rounded-lg">
      <Link className="w-4 h-4 text-orange-600" />
      <span className="text-sm font-medium text-orange-700 dark:text-orange-400">
        {t('amazonListing.manual.linkedWith')}: {product.name}
      </span>
      {product.first_image_url && <img src={product.first_image_url} alt="" className="w-8 h-8 rounded object-cover ml-auto" />}
      <button onClick={onClear} className="p-1 hover:bg-orange-100 dark:hover:bg-orange-900 rounded">
        <X className="w-4 h-4 text-orange-600" />
      </button>
    </div>
  )
}
